module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am509-12a2e2303aaa0ab55522255729f21053.jpg";